
import { Options, prop, Vue } from "vue-class-component";
import { RecipientTag } from "@/domain/entities/PrintReceipt";
import ModalSendInvoicePicker from "./ModalSendInvoicePicker.vue";

class Props {
  label = prop<string>({
    default: "Kirim Ke"
  });
  isOptional = prop<boolean>({
    default: true
  });
  pickerHeight = prop<string>({
    default: "70px"
  });
  modelValue = prop<RecipientTag[]>({
    default: () => []
  });
}

@Options({
  components: {
    ModalSendInvoicePicker
  },
  emits: ["update:modelValue"],
})
class InvoiceRecipientTagPicker extends Vue.with(Props) {
  showModal = false;

  openModal() {
    this.showModal = true;
  }

  handleModalSubmit(tags: RecipientTag[]) {
    const newTags = [...this.modelValue, ...tags];
    this.$emit("update:modelValue", newTags);
    this.showModal = false;
  }

  removeTag(index: number) {
    const newTags = [...this.modelValue];
    newTags.splice(index, 1);
    this.$emit("update:modelValue", newTags);
  }
}

export default InvoiceRecipientTagPicker;
